const CUSTOMER_PROCESSING_FEE_RATE = 0.051;
const CUSTOMER_PROCESSING_FIXED_FEE_CENTS = 30;

export function calculateCustomerFacingProcessingFeeCents(baseAmountCents: number): number {
  if (!Number.isFinite(baseAmountCents) || baseAmountCents <= 0) return 0;
  return Math.max(
    0,
    Math.round(baseAmountCents * CUSTOMER_PROCESSING_FEE_RATE) +
      CUSTOMER_PROCESSING_FIXED_FEE_CENTS,
  );
}

export function calculateCustomerFacingTotalCents(baseAmountCents: number): number {
  if (!Number.isFinite(baseAmountCents) || baseAmountCents <= 0) return 0;
  return Math.max(0, baseAmountCents + calculateCustomerFacingProcessingFeeCents(baseAmountCents));
}

export function formatUsdCents(amountCents: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format((Number(amountCents) || 0) / 100);
}
